<template>
  <transition name="fade">
    <div v-if="$store.state.loginState" class="login-container">
      <div class="shadow-wrapt"></div>
      <div class="login-wrapt">
        <!--登录  -->
        <transition name="plus-icon">
          <div class="logincontent" v-if="loginparameters.logindata == true">
            <LoginModule :loginparameters="loginparameters" />
          </div>
        </transition>
        <!--注册 -->
        <transition name="plus-icon">
          <div class="forgetcontent" v-if="loginparameters.registration == true">
            <SetuesName :loginparameters="loginparameters" @login="login" />
          </div>
        </transition>
        <!-- 忘记密码 -- 验证 -->
        <transition name="plus-icon">
          <div class="forgetcontent" v-if="loginparameters.forgetdata == true">
            <ForgetPassword :loginparameters="loginparameters" @login="login" />
          </div>
        </transition>
        <!-- 忘记密码 -->
        <transition name="plus-icon">
          <div
            class="settingcontent"
            v-if="loginparameters.settingdata == true"
          >
            <SettingPassword
              :loginparameters="loginparameters"
              @login="login"
            />
          </div>
        </transition>
        <!-- 账号默认密码时弹窗 -->
        <transition name="plus-icon">
          <div
            class="settingcontent"
            v-if="loginparameters.defaultdata == true"
          >
            <DefaultPassword :loginparameters="loginparameters" />
          </div>
        </transition>
        <!-- Ip验证 -->
        <transition name="plus-icon">
          <div class="settingcontent" v-if="loginparameters.Ipstate == true">
            <IPverification :loginparameters="loginparameters" />
          </div>
        </transition>
      </div>
    </div>
    <div v-if="$store.state.eduCubeState" class="login-container">
      <div class="shadow-wrapt"></div>
      <!-- 魔方账号绑定 -->
      <transition name="plus-icon">
        <div class="logincontent">
          <eduCubeBind :loginparameters="loginparameters" />
        </div>
      </transition>
    </div>
    <!-- <div v-if="$store.state.versionsstate" class="login-container">
      <div class="shadow-wrapt"></div>
      <transition name="plus-icon">
        <div class="logincontent">
          <versions-uploading />
        </div>
      </transition>
    </div> -->
  </transition>
</template>

<script>
import LoginModule from "@/components/wx-loginmodule";
import eduCubeBind from "@/components/wx-eduCubeBind";
import ForgetPassword from "@/components/wx-forgetpassword";
import SettingPassword from "@/components/wx-settingpassword";
import DefaultPassword from "@/components/setpassword";
import SetuesName from "@/components/setuesName";
import IPverification from "@/components/IP_verification";
// import versionsUploading from "@/components/versions-uploading";
export default {
  components: {
    LoginModule,
    ForgetPassword,
    SettingPassword,
    DefaultPassword,
    IPverification,
    eduCubeBind,
    SetuesName
    // versionsUploading
  },
  data() {
    return {
      loginparameters: {
        logindata: true,
        forgetdata: false,
        settingdata: false,
        defaultdata: false,
        registration: false,
        Ipstate: false,
        settingUsername: "", //用户
        settingCode: "", //修改验证码
        name: "", //用户真实姓名
        username: "",
        setCode: "", //设置密码验证码
        phone: "" //设置密码手机号
      }
    };
  },
  computed: {},
  methods: {
    initialize() {},
    enterKeyupDestroyed() {
      document.removeEventListener("keyup", this.enterKey);
    },
    enterKeyup() {
      document.addEventListener("keyup", this.enterKey);
    },
    login() {
      // if(localStorage.defaultdata){
      //   let add = localStorage.defaultdata;
      //   if(add === true){
      //     // this.loginparameters.logindata = false;
      //     // this.loginparameters.defaultdata = true;
      //     this.loginparameters.logindata = false;
      //     this.loginparameters.forgetdata = false;
      //     this.loginparameters.settingdata = false;
      //     this.loginparameters.defaultdata = true;
      //     this.loginparameters.Ipstate = false;
      //   }
      // }else if(localStorage.IPveiwdata){
      //   let add = localStorage.IPveiwdata;
      //   if(add === true){
      //     this.loginparameters.logindata = false;
      //     this.loginparameters.forgetdata = false;
      //     this.loginparameters.settingdata = false;
      //     this.loginparameters.defaultdata = false;
      //     this.loginparameters.Ipstate = true;
      //   }
      // }else{
      this.loginparameters.logindata = true;
      this.loginparameters.forgetdata = false;
      this.loginparameters.settingdata = false;
      this.loginparameters.defaultdata = false;
      this.loginparameters.Ipstate = false;
      this.loginparameters.registration = false;
      // }
    }
  },
  mounted() {
    this.enterKeyup();
  },
  destroyed() {
    // 销毁enter事件
    this.enterKeyupDestroyed();
  },
  created() {
    this.login();
  },
  updated() {}
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-active {
  opacity: 0
}
@import './index.styl';
</style>



// WEBPACK FOOTER //
// src/components/dialog_login/index.vue